import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';

import {
  USER_COMPANIES_DASHBOARD_DATA_SUCCESS,
  LOGGED_USER_INFO_SUCCESS,
  LOGGED_USER_INFO_ERROR,
  CHANGE_CURRENT_COMPANY,
  LOGGED_USER_INFO_REQUEST,
  SET_CURRENT_COMPANY_API_KEY_SUCCESS,
  USER_FINANCIALS_DATA_SUCCESS,
  ACCEPT_TERMS_OF_USE_SUCCESS,
  USER_FINANCIALS_DATA_ERROR,
  GO_TO_NEXT_NOTIFICATION,
  GET_COMPANIES_SUCCESS,
  SET_ACCOUNTING_ACCESS_LINK,
} from 'modules/loggedUserInfo/actions';

const initialState = {
  info: {
    data: {
      companies: [],
      current: { name: '' },
      companiesDashboardData: [],
      financials: { debtors: 'N/A', creditors: 'N/A' },
      user: {
        termsAccepted: true,
        notifications: [],
      },
    },
    error: '',
    status: STATUS_NOT_REQUESTED,
  },
  notificationIndex: 0,
  accountingLink: null,
};

export const loggedUserInfo = (state = initialState, action) => {
  switch (action.type) {
    case LOGGED_USER_INFO_REQUEST:
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUS_LOADING,
        },
      };

    case LOGGED_USER_INFO_SUCCESS: {
      const { modules, primaryCompanyData, userData } = action.payload;
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUS_SUCCESS,
          data: {
            ...state.info.data,
            authorizedModules: modules,
            user: userData,
            current: primaryCompanyData,
          },
        },
      };
    }

    case GET_COMPANIES_SUCCESS: {
      const { companies } = action.payload;
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            companies,
          },
        },
      };
    }

    case LOGGED_USER_INFO_ERROR: {
      const error = action.payload;
      return {
        ...state,
        info: {
          ...state.info,
          status: STATUS_ERROR,
          error,
        },
      };
    }

    case CHANGE_CURRENT_COMPANY: {
      const { companyId } = action.payload;
      const companyData = state.info.data.companies.find(
        (company) => company.id === companyId
      );
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            current: companyData,
          },
        },
      };
    }

    case SET_CURRENT_COMPANY_API_KEY_SUCCESS: {
      const { data } = action.payload;
      const updatedCompanies = state.info.data.companies.map((company) =>
        company.id === data.id ? data : company
      );
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            companies: updatedCompanies,
            current: data,
          },
        },
      };
    }

    case USER_COMPANIES_DASHBOARD_DATA_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            companiesDashboardData: data,
          },
        },
      };
    }

    case USER_FINANCIALS_DATA_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            financials: data,
          },
        },
      };
    }

    case USER_FINANCIALS_DATA_ERROR:
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            financials: { debtors: 'N/A', creditors: 'N/A' },
          },
        },
      };

    case ACCEPT_TERMS_OF_USE_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          data: {
            ...state.info.data,
            user: {
              ...state.info.data.user,
              termsAccepted: true,
            },
          },
        },
      };

    case GO_TO_NEXT_NOTIFICATION:
      return {
        ...state,
        notificationIndex: state.notificationIndex + 1,
      };

    case SET_ACCOUNTING_ACCESS_LINK:
      return {
        ...state,
        accountingLink: action.payload,
      };

    default:
      return state;
  }
};
